import { makeDateWindowSchema } from "./dateWindow.js";
/**
 * Dashboard READ endpoints — wire types for the org-pulse lenses.
 *
 * Plain RLS-scoped reads: the Hono handler calls a SECURITY INVOKER RPC
 * through the per-request user client, so org RLS authorizes and this layer
 * adds no privilege. New dashboard reads belong here rather than as another
 * direct `supabase.rpc()` in useDashboardSummary.ts (docs/BACKEND_API.md).
 *
 * Shared by the API handler (response construction) and the web hook (unwrap
 * target) so the two cannot drift. Template: placesReads.ts.
 */
/** The five aging buckets used across the app — `getAgingBucketKey()` below
 * is the one rule that assigns them (the web's aging-utils, the debtor /
 * creditor lists and get_ar_ap_aging_buckets agree on it). Order is display
 * order, oldest last. */
export const AGING_BUCKETS = ["current", "1-30", "31-60", "61-90", "90+"];
/**
 * The aging bucket for a number of days past due: not yet due or due today
 * (`<= 0`) is `current`, then 1-30, 31-60, 61-90 and 90+. THE one bucket rule —
 * `apps/web/src/lib/aging-utils.ts` re-exports it and the debtor / creditor
 * lists (`documents/openItems`) bucket with it.
 */
export function getAgingBucketKey(daysOverdue) {
    if (daysOverdue <= 0)
        return "current";
    if (daysOverdue <= 30)
        return "1-30";
    if (daysOverdue <= 60)
        return "31-60";
    if (daysOverdue <= 90)
        return "61-90";
    return "90+";
}
/**
 * Window for the monthly-net-flow read. Both bounds are REQUIRED: the RPC would
 * happily aggregate an org's entire history, and "bounded by construction" only
 * holds if this route insists on a window.
 *
 * Capped at 36 months because this RPC ZERO-FILLS via generate_series, so its
 * row count tracks the requested span rather than the org's data — an
 * unbounded window returns ~120,000 rows for a caller with one transaction.
 * The UI only ever asks for 6 (`trailingMonthsWindow`), so 36 is six-fold
 * headroom and still bounds the pathological case.
 */
export const monthlyNetFlowQuerySchema = makeDateWindowSchema(36);
//# sourceMappingURL=dashboardReads.js.map